
import {defineComponent, ref, Ref} from "vue";
import {useStore} from "vuex";
import {dispatchError} from "../../utils/error_handling";
import {ContentAnnotation} from "./helpers";

export default defineComponent({
  name: "ContentAnnotationForm",
  setup() {
    const store = useStore();
    const input: Ref<string> = ref("");

    const onInput = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/annotation/takingNotes", new ContentAnnotation(input.value));
      } catch (e) {
        console.error("[onInput] Error ", e);
        await dispatchError(e);
      }
    };

    const onSubmit = async (): Promise<void> => {
      try {
        await createAnnotation();
        clearTextArea();
      } catch (e) {
        console.error("[onSubmit] Error ", e);
        await dispatchError(e);
      }
    };

    const createAnnotation = async (): Promise<void> => {
      try {
        const lastPausedTime = store.getters["content_module/player/lastPausedTime"];
        const annotation = new ContentAnnotation(input.value, lastPausedTime);
        await store.dispatch("content_module/annotation/createAnnotation", annotation);
      } catch (e) {
        console.error("[createAnnotation] Error ", e);
        throw e;
      }
    };

    const clearTextArea = () => {
      input.value = "";
    };

    return {
      input,
      onInput,
      onSubmit
    };
  }
});
